<template>
  <main>
    <section class="admin-page">
      <div class="admin-toolbar">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          solo
          flat
          dense
          hide-details
          placeholder="Buscar usuário..."
          background-color="surface_tertiary"
          v-model="filtro_texto"
          class="admin-search"
        />
      </div>
      <div class="admin-table-wrapper">
        <DataTables
          v-if="usuarios"
          :data="filteredUsuarios"
          :headers="headers"
          tab="usuarios"
        />
      </div>
    </section>
  </main>
</template>

<script>
import DataTables from "../components/DataTables.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "UsuariosView",
  components: { DataTables },
  data() {
    return {
      page: 1,
      size: 20,
      filtro_texto: "",
      dsc_login_usuario_perfil: "",
      isModalVisible: false,
      tableData: [],
      timer: null,
      headers: [
        {
          align: "start",
          sortable: false,
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
        {
          text: "Usuário",
          sortable: false,
          name: "users",
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
        {
          text: "Perfil",
          sortable: false,
          name: "perfil",
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
      ],
    };
  },
  async created() {
    await this.fetchData();
  },
  computed: {
    ...mapGetters({
      usuarios: "users/getterUsers",
    }),
    filteredUsuarios() {
      if (this.filtro_texto) {
        return this.usuarios.items.filter((item) => {
          return item.dsc_login_usuario
            .toLowerCase()
            .includes(this.filtro_texto.toLowerCase());
        });
      }
      return this.usuarios.items;
    },
  },
  methods: {
    ...mapActions({
      getUsuarios: "users/getUsers",
    }),
    async fetchData() {
      try {
        await this.getUsuarios({
          page: this.page,
          size: this.size,
          dsc_excecao: this.dsc_login_usuario_perfil,
        });
      } catch (error) {
        this.$toast.error("Erro ao buscar usuários.");
      }
    },
  },
};
</script>

